import {
  combineReducers,
  ThunkAction,
  configureStore,
  AnyAction,
} from '@reduxjs/toolkit'

import events from './events/events'
import registrations from './registrations/registrations'
import program from './program/program'
import institution from './institution/institution'
import paymentData from './paymentData'
import misc from './misc/misc'
import participant from './participant/participant'

const appReducer = combineReducers({
  events,
  registrations,
  program,
  institution,
  misc,
  paymentData,
  participant,
})

export const store = configureStore({
  reducer: appReducer,
})

export default store

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  AnyAction
>
